<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 10"
    fill="currentColor"
    aria-hidden="true"
  >
    <rect
      x="0"
      y="7"
      width="2.5"
      height="3"
      rx=".5"
    />
    <rect
      x="4"
      y="5"
      width="2.5"
      height="5"
      rx=".5"
    />
    <rect
      x="8"
      y="3"
      width="2.5"
      height="7"
      rx=".5"
    />
    <rect
      x="12"
      y="0"
      width="2.5"
      height="10"
      rx=".5"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSignalBars',
  props: {
    width: { type: [String, Number], default: 16 },
    height: { type: [String, Number], default: 10 },
  },
};
</script>
